<template>
  <section>
    <form
      @submit="onSubmit"
      v-if="hideForm === false"
      class="c-form"
    >
      <h3 class="c-form__title">
        {{ title }}
      </h3>
      <div
        v-if="lead"
        v-html="lead"
        class="c-form__lead"
      />
      <p class="c-form__label-and-input">
        <label for="name">Navn*</label>
        <input
          id="name"
          v-model="formInput.name"
          type="text"
          name="name"
          required
        >
      </p>
      <p class="c-form__label-and-input">
        <label for="email">E-post*</label>
        <input
          id="email"
          v-model="formInput.email"
          type="email"
          name="email"
          required
        >
      </p>
      <p class="c-form__label-and-input">
        <label for="phone">Telefon*</label>
        <input
          id="phone"
          v-model="formInput.phone"
          type="text"
          name="phone"
          required
        >
      </p>
      <p class="c-form__label-and-input">
        <input
          id="consent"
          v-model="formInput.consent"
          :value="consent"
          type="checkbox"
          name="consent"
          required
        >
        <label for="consent">
          {{ consent }}
        </label>
      </p>
      <button
        :disabled="formInput.consent != true"
        type="submit"
        title="Du må godkjenne før du kan sende inn skjemaet"
      >
        Send
      </button>
    </form>
    <div
      v-else
      class="c-form"
    >
      <h2>Tusen takk.</h2>
      <p>Vi har nå mottatt din melding og vil kontakte deg snarest.</p>
      <button 
        @click="showForm" 
        @keyup.enter="showForm" 
        type="button" 
        class="c-btn
        c-btn--secondary"
      >
        Vis skjemaet igjen
      </button>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
//import { required, minLength, } from 'vuelidate/lib/validators';
//import querystring from 'querystring';

import Option from '@/models/Option';
import Residence from '@/models/Residence';
import Selector from '@/models/Selector';

export default {
  name: 'ContactForm',
  props: {
    residenceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formInput: {
        name: '',
        email: '',
        phone: '',
        consent: '',
      },
      hideForm: false,
    };
  },
  computed: {
    residence() {
      return Residence.find(this.residenceId);
    },
    selector() {
      return Selector.query().first();
    },
    options() {
      return Option.query()
        .where('isSelected', true)
        .with('category')
        .get();
    },
    title() {
      return this.selector.contactFormTitle;
    },
    lead() {
      return this.selector.contactFormLead;
    },
    consent() {
      return this.selector.contactFormConcent;
    },
    url() {
      const baseURL = window.__selector_settings__.sourceData.sourceURL;
      const contactFormId = this.selector.contactForm;
      if (baseURL != false) {
        return baseURL + '/wp-json/contact-form-7/v1/contact-forms/' + contactFormId + '/feedback';
      } else {
        return '/wp-json/contact-form-7/v1/contact-forms/' + contactFormId + '/feedback';
      }
    },
    info() {
      let values = {};
      values.Name = this.formInput.name;
      values.email = this.formInput.email;
      values.phone = this.formInput.phone;
      values.consent = this.formInput.consent;
      if (this.residence.airtableId) {
        values.Boliger = [this.residence.airtableId,];
      }

      // TODO: Oppdatere med tilvalg
      /* values.options = '';
      this.options.forEach(option => {
        values.options +=
          option.category.name +
          ': ' +
          option.name +
          ', ' +
          option.currentPrice.toLocaleString('nb-NO') +
          ',–, \n';
      }); */
      return values;
    },
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      // Make.com endpoint for no-code scenario
      const endpoint = 'https://hook.eu1.make.com/3hwt8d1h6pv71cb2law8ekbithi7gszi';

      // Use Axios.js for sending data to make.com scenario using POST
      axios({
        method: 'post',
        url: endpoint,
        data: {
          // Airtable wants data wrapped in 'fields'
          fields: this.info,
        },
      }).then(response => {
        // When the server responds hide the form
        this.hideForm = true;

        // Register a Google Analytics event if GA is active on page.
        this.$gtag.event('generate_lead', {
          event_category: 'engagement',
          event_label: `Meld interesse for ${this.residence.name}`,
          value: 1,
        });
      }).catch(error => {
        // TODO: Create a better error reporting flow.
        console.log(error);
      });
    },
    showForm() {
      this.hideForm = false;
    },
  },
};
</script>
